"use strict";

const ActivityInventoryContacts = function () {
  const stringKey = "contacts";
  const headerInformation = "Contacts";
  let $page;

  var loadActivityInfoListeners = function () {
    Form.initializeAndLoadListeners(
      $page,
      ActivityInventoryModalController.getActivityInventoryFormKey(),
      { isMultiPart: true },
    );
    $page.on("click", ".new-contact-button", createNewContact);
    $page.on("click", ".edit-button", editContact);
    $page.on("click", ".save-button", saveContact);
    $page.on("click", ".delete-button", deleteExistingContact);
    $page.on("click", ".delete-editing-button", deleteEditingContact);
    $page.on("click", ".save-initial-button", saveInitialContact);
  };

  var removeActivityInfoListeners = function () {
    $page.off("click", ".new-contact-button", createNewContact);
    $page.off("click", ".edit-button", editContact);
    $page.off("click", ".save-button", saveContact);
    $page.off("click", ".delete-button", deleteExistingContact);
    $page.off("click", ".delete-editing-button", deleteEditingContact);
    $page.off("click", ".save-initial-button", saveInitialContact);
  };

  var getStringKey = function () {
    return stringKey;
  };

  var getHeaderInformation = function () {
    return headerInformation;
  };

  var render = async function (options = {}) {
    const renderData = getContactProps();
    await renderPageHtml(renderData);
    loadActivityInfoListeners();
    setInitialState(renderData, options);
  };

  var renderPageHtml = async function (renderData) {
    const html = await nunjucks.asyncRender("modals/peo/activityInventoryContacts.njk", {
      ...renderData,
    });
    ActivityInventoryModalController.renderPageContent(html);
    $page = $("#inventory-modal .modal-dynamic-content").assertLength(1);
  };

  var getContactProps = function () {
    const props = ActivityInventoryModalController.getActivityInventoryData();
    const contacts = props?.contacts ?? [];
    const filteredContacts = contacts
      .filter((contact) => !contact.deleted)
      .map((contact) => ({
        ...contact,
        displayRole: getDisplayRoleFromContact(contact),
        fullMailingAddress:
          contact.fullMailingAddress ??
          Misc.getFullMailingAddress(
            contact.mailingAddress,
            contact.city,
            contact.state,
            contact.zipCode,
          ),
      }))
      .sort((a, b) => a.id - b.id);

    return {
      contacts: filteredContacts,
      constants: {
        contactRoles: getRoleOptions(),
      },
    };
  };

  var cleanUp = function () {
    removeActivityInfoListeners();
    $page.empty();
    return true;
  };

  var validate = function () {
    return true;
  };

  var setInitialState = function (props, options) {
    const currentContactsLength = props?.contacts?.length ?? 0;
    if (options.editContact) {
      editContactById(options.editContact);
    } else if (currentContactsLength > 0 && options.newContact) {
      createNewContact();
    } else if (currentContactsLength === 0 || options.newContact) {
      $page.find(".new-contact-button").hide();
      stageInitialContact();
    }
  };

  var toggleEditSaveButtonsDisabled = function (disabled) {
    if (disabled === false) {
      $page.find(".new-contact-button").show();
    }
    $page.find(".edit-button, .new-contact-button").prop("disabled", disabled);
  };

  var createNewContact = function () {
    const { html, currentContactsLength, newContact } = createContactHtml(false);
    ActivityInventoryModalController.setFormDataField(
      ["contacts", currentContactsLength],
      newContact,
    );
    toggleEditSaveButtonsDisabled(true);
    $page.find(".activity-contacts").prepend(html);
  };

  var editContactById = function (contactId) {
    const contactRoles = getRoleOptions();
    const contactInfo = getContactInfoById(contactId);
    const html = nunjucks.render("modals/peo/activityInventoryModifyContact.njk", {
      constants: { contactRoles },
      contact: contactInfo,
      index: getContactIndexById(contactInfo.id),
    });
    $page.find(`.contact[data-id=${contactId}]`).html(html);
    toggleEditSaveButtonsDisabled(true);
  };

  var editContact = function (e) {
    const $contact = $(e.currentTarget);
    const contactId = $contact.closest(".contact").data("id");
    editContactById(contactId);
  };

  var saveContact = function (e) {
    const $contact = $(e.currentTarget);
    const contactId = $contact.closest(".contact").data("id");
    const contactInfo = getContactInfoById(contactId);
    if (contactInfo === undefined) throw new Error(`Couldn't get contact with id ${contactId}.`);
    contactInfo.displayRole = getDisplayRoleFromContact(contactInfo);
    contactInfo.fullMailingAddress =
      contactInfo.fullMailingAddress ??
      Misc.getFullMailingAddress(
        contactInfo.mailingAddress,
        contactInfo.city,
        contactInfo.state,
        contactInfo.zipCode,
      );

    const html = nunjucks.render("modals/peo/activityInventoryExistingContact.njk", {
      contact: contactInfo,
    });
    $contact.closest("section").html(html);
    toggleEditSaveButtonsDisabled(false);
    removeInitialInputListener();
  };

  var removeInitialInputListener = function () {
    const length = getContactLength() - 1;
    $page.off("input", `[name*="contacts[${length}]"]`, stageInitialId);
  };

  var deleteContact = function (contactId) {
    const contactIndex = getContactIndexById(contactId);
    const existingContactIds = (
      ActivityInventoryModalController.getExistingData("contacts") || []
    ).map((contact) => {
      return contact.id;
    });

    if (existingContactIds.includes(contactId)) {
      ActivityInventoryModalController.setFormDataField(["contacts", contactIndex], {
        deleted: true,
        id: contactId,
      });
    } else {
      ActivityInventoryModalController.unsetFormDataField(["contacts", contactIndex]);
    }
    $(`[data-id="${contactId}"]`).remove();
  };

  var deleteExistingContact = function (e) {
    const $contact = $(e.currentTarget);
    const contactId = $contact.closest(".contact").data("id");
    const contactInfo = getContactInfoById(contactId);
    const fullName = `${contactInfo.firstName || ""} ${contactInfo.lastName || ""}`;
    const deleteExistingContactCallback = () => {
      deleteContact(contactId);
    };

    MessageModal.showDeleteContactModal(fullName, deleteExistingContactCallback);
  };

  var deleteEditingContact = function (e) {
    const $contact = $(e.currentTarget);
    const contactId = $contact.closest(".contact").data("id");
    const contactInfo = getContactInfoById(contactId);
    if (contactInfo) {
      const fullName = `${contactInfo.firstName || ""} ${contactInfo.lastName || ""}`;
      const deleteEditingContactCallback = () => {
        deleteContact(contactId);
        toggleEditSaveButtonsDisabled(false);
      };
      MessageModal.showDeleteContactModal(fullName, deleteEditingContactCallback);
    } else {
      removeInitialInputListener();
      $(`[data-id="${contactId}"]`).remove();
      toggleEditSaveButtonsDisabled(false);
    }
  };

  var stageInitialContact = function () {
    const { html, currentContactsLength } = createContactHtml(true);
    toggleEditSaveButtonsDisabled(true);
    $page.find(".activity-contacts").prepend(html);
    $page.on("input", `[name*="contacts[${currentContactsLength}]"]`, stageInitialId);
  };

  var saveInitialContact = function (e) {
    const contactLength = getContactLength();
    setFormInitialState(contactLength);
    saveContact(e);
  };

  var createContactHtml = function (initialContact = false) {
    const contactRoles = getRoleOptions();
    const newId = Date.now();
    const newContact = { id: newId, role: contactRoles[0].value };
    const currentContactsLength = getContactLength();
    return {
      html: nunjucks.render("modals/peo/activityInventoryNewContact.njk", {
        constants: { contactRoles },
        contact: newContact,
        index: currentContactsLength,
        initialContact: initialContact,
      }),
      currentContactsLength: currentContactsLength,
      newContact: newContact,
    };
  };

  var getContactLength = function () {
    const data = ActivityInventoryModalController.getActivityInventoryData();
    return data?.contacts?.length ?? 0;
  };

  var stageInitialId = function () {
    const contactLength = Math.max(0, getContactLength() - 1);
    setFormInitialState(contactLength);
    $page.off("input", `[name*="contacts[${contactLength}]"]`, stageInitialId);
  };

  var setFormInitialState = function (contactLength = 0) {
    const newContactId = $page.find(".activity-contacts .contact").data("id");
    if (!getContactInfoById(newContactId)) {
      const newContactRole = $page.find(`[name="contacts[${contactLength}][role]"]`).val();
      ActivityInventoryModalController.setFormDataField(
        ["contacts", contactLength, "id"],
        newContactId,
      );
      ActivityInventoryModalController.setFormDataField(
        ["contacts", contactLength, "role"],
        newContactRole,
      );
    }
  };

  var getContactIndexById = function (contactId) {
    const data = ActivityInventoryModalController.getActivityInventoryData();
    if (data.contacts) {
      return data.contacts.findIndex((contact) => {
        return contactId === (contact || {}).id;
      });
    }
  };

  var getContactInfoById = function (contactId) {
    const data = ActivityInventoryModalController.getActivityInventoryData();
    const contactIndex = getContactIndexById(contactId);

    return contactIndex === undefined ? undefined : data.contacts[contactIndex];
  };

  var getDisplayRoleFromContact = function (contact) {
    const roles = getRoleOptions();
    const matchingRole = roles.find((options) => {
      return options.value === contact.role;
    });

    if (matchingRole === undefined) {
      return contact.displayRole;
    }

    return matchingRole.name;
  };

  var getRoleOptions = function () {
    return ActivityConstants.get().contactRoles;
  };

  return {
    getStringKey,
    getHeaderInformation,
    render,
    renderPageHtml,
    cleanUp,
    validate,
  };
};

module.exports = ActivityInventoryContacts();

const Form = require("../general/form");
const ActivityInventoryModalController = require("./activityInventoryModalController");
const MessageModal = require("../modals/messageModal");
const Misc = require("../misc");
const ActivityConstants = require("./activityConstants");
